import { unref, watch, type MaybeRef, type Ref } from 'vue'
import type { Message } from '#entities/message'

export function useSmoothMessagesAppearing(
  scrollerEl: MaybeRef<HTMLElement | null>,
  lastMessage: Ref<Message | undefined>,
  areFreshMessagesDisplayed: Ref<boolean>
) {
  const scrollBottomTreshold = 10

  watch(
    [lastMessage, areFreshMessagesDisplayed],
    ([lastMessage, areFreshMessagesDisplayed], [prevLastMessage, prevAreFreshMessagesDisplayed]) => {
      if (lastMessage === prevLastMessage) return // React only to last message change
      if (!areFreshMessagesDisplayed) return // Don't scroll if old messages loaded
      if (areFreshMessagesDisplayed && !prevAreFreshMessagesDisplayed) return // Don't scroll if fresh messages are just being loaded

      const scrollerElVal = unref(scrollerEl)
      if (!scrollerElVal) return

      const scrollBottom = scrollerElVal.scrollHeight - scrollerElVal.clientHeight - scrollerElVal.scrollTop
      if (scrollBottom <= scrollBottomTreshold) {
        setTimeout(() => {
          scrollerElVal.scrollTo({
            behavior: 'smooth',
            top: scrollerElVal.scrollHeight,
          })
        })
      }
    }
  )
}
